<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="shuo-gua show-book">
      <h5>【說卦】</h5>
      <p>
        昔者聖人之作易也，幽贊於神明而生蓍，參天兩地而倚數，觀變於陰陽而立卦，發揮於剛柔而生爻。和順於道德而理於義，窮理盡性以至於命。
      </p>
      <p>
        昔者聖人之作易也，將以順性命之理，是以立天之道，曰陰與陽；立地之道，曰柔與剛；立人之道，曰仁與義。兼三才而兩之，故易六畫而成卦；分陰分陽，迭用柔剛，故易六位而成章。
      </p>
      <p>
        天地定位，山澤通氣，雷風相薄，水火不相射，八卦相錯。數往者順，知來者逆，是故易逆數也。
      </p>
      <p>
        雷以動之，風以散之，雨以潤之，日以烜之，艮以止之，兌以說之，乾以君之，坤以藏之。
      </p>
      <p>
        帝出乎震，齊乎巽，相見乎離，致役乎坤，說言乎兌，戰乎乾，勞乎坎，成言乎艮。
      </p>
      <p>
        萬物出乎震，震，東方也。齊乎巽，巽，東南也。齊也者，言萬物之潔齊也。
      </p>
      <p>
        離也者，明也。萬物皆相見，南方之卦也。聖人南面而聽天下，嚮明而治，蓋取諸此也。
      </p>
      <p>坤也者，地也。萬物皆致養焉，故曰「致役乎坤」。</p>
      <p>兌，正秋也，萬物之所說也，故曰「說言乎兌」。</p>
      <p>戰乎乾，乾，西北之卦也，言陰陽相薄也。</p>
      <p>坎者，水也，正北方之卦也，勞卦也，萬物之所歸也，故曰「勞乎坎」。</p>
      <p>艮，東北之卦也，萬物之所成終而所成始也，故曰「成言乎艮」。</p>
      <p>
        神也者，妙萬物而為言者也。動萬物者，莫疾乎雷；橈萬物者，莫疾乎風；
        燥萬物者，莫熯乎火；說萬物者，莫說乎澤；潤萬物者，莫潤乎水；
        終萬物、始萬物者，莫盛乎艮。故水火相逮，雷風不相悖，山澤通氣，然後能變化，既成萬物也。
      </p>
      <p>
        乾，健也；坤，順也；震，動也；巽，入也；坎，陷也；離，麗也；艮，止也；兌，說也。
      </p>
      <p>乾為馬，坤為牛，震為龍，巽為雞，坎為豕，離為雉，艮為狗，兌為羊。</p>
      <p>乾為首，坤為腹，震為足，巽為股，坎為耳，離為目，艮為手，兌為口。</p>
      <p>
        乾，天也，故稱乎父；坤，地也，故稱乎母；
        震，一索而得男，故謂之長男；巽，一索而得女，故謂之長女；
        坎，再索而得男，故謂之中男；離，再索而得女，故謂之中女；
        艮，三索而得男，故謂之少男；兌，三索而得女，故謂之少女。
      </p>
      <p>
        乾為天，為圜，為君，為父，為玉，為金，為寒，為冰，為大赤，為良馬，為老馬，為瘠馬，為駁馬，為木果。
      </p>
      <p>
        坤為地，為母，為布，為釜，為吝嗇，為均，為子母牛，為大輿，為文，為眾，為柄；其於地也，為黑。
      </p>
      <p>
        震為雷，為龍，為玄黃，為旉，為大塗，為長子，為決躁，為蒼筤竹，為萑葦；其於馬也，為善鳴，為馵足，為作足，為的顙；其於稼也，為反生；其究為健，為蕃鮮。
      </p>
      <p>
        巽為木，為風，為長女，為繩直，為工，為白，為長，為高，為進退，為不果，為臭；其於人也，為寡髮，為廣顙，為多白眼，為近利市三倍；其究為躁卦。
      </p>
      <p>
        坎為水，為溝瀆，為隱伏，為矯輮，為弓輪；其於人也，為加憂，為心病，為耳痛，為血卦，為赤；其於馬也，為美脊，為亟心，為下首，為薄蹄，為曳；其於輿也，為多眚，為通，為月，為盜；其於木也，為堅多心。
      </p>
      <p>
        離為火，為日，為電，為中女，為甲冑，為戈兵；其於人也，為大腹，為乾卦，為鱉，為蟹，為蠃，為蚌，為龜；其於木也，為科上槁。
      </p>
      <p>
        艮為山，為徑路，為小石，為門闕，為果蓏，為閽寺，為指，為狗，為鼠，為黔喙之屬；其於木也，為堅多節。
      </p>
      <p>
        兌為澤，為少女，為巫，為口舌，為毀折，為附決；其於地也，為剛鹵，為妾，為羊。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="shuo-gua show-book">
      <h5>【说卦】</h5>
      <p>
        昔者圣人之作易也，幽赞于神明而生蓍，参天两地而倚数，观变于阴阳而立卦，发挥于刚柔而生爻。和顺于道德而理于义，穷理尽性以至于命。
      </p>
      <p>
        昔者圣人之作易也，将以顺性命之理，是以立天之道，曰阴与阳；立地之道，曰柔与刚；立人之道，曰仁与义。兼三才而两之，故易六画而成卦；分阴分阳，迭用柔刚，故易六位而成章。
      </p>
      <p>
        天地定位，山泽通气，雷风相薄，水火不相射，八卦相错。数往者顺，知来者逆，是故易逆数也。
      </p>
      <p>
        雷以动之，风以散之，雨以润之，日以烜之，艮以止之，兑以说之，乾以君之，坤以藏之。
      </p>
      <p>
        帝出乎震，齐乎巽，相见乎离，致役乎坤，说言乎兑，战乎乾，劳乎坎，成言乎艮。
      </p>
      <p>
        万物出乎震，震，东方也。齐乎巽，巽，东南也。齐也者，言万物之洁齐也。
      </p>
      <p>
        离也者，明也。万物皆相见，南方之卦也。圣人南面而听天下，向明而治，盖取诸此也。
      </p>
      <p>坤也者，地也。万物皆致养焉，故曰「致役乎坤」。</p>
      <p>兑，正秋也，万物之所说也，故曰「说言乎兑」。</p>
      <p>战乎乾，乾，西北之卦也，言阴阳相薄也。</p>
      <p>坎者，水也，正北方之卦也，劳卦也，万物之所归也，故曰「劳乎坎」。</p>
      <p>艮，东北之卦也，万物之所成终而所成始也，故曰「成言乎艮」。</p>
      <p>
        神也者，妙万物而为言者也。动万物者，莫疾乎雷；桡万物者，莫疾乎风；
        燥万物者，莫熯乎火；说万物者，莫说乎泽；润万物者，莫润乎水；
        终万物、始万物者，莫盛乎艮。故水火相逮，雷风不相悖，山泽通气，然后能变化，既成万物也。
      </p>
      <p>
        乾，健也；坤，顺也；震，动也；巽，入也；坎，陷也；离，丽也；艮，止也；兑，说也。
      </p>
      <p>乾为马，坤为牛，震为龙，巽为鸡，坎为豕，离为雉，艮为狗，兑为羊。</p>
      <p>乾为首，坤为腹，震为足，巽为股，坎为耳，离为目，艮为手，兑为口。</p>
      <p>
        乾，天也，故称乎父；坤，地也，故称乎母；
        震，一索而得男，故谓之长男；巽，一索而得女，故谓之长女；
        坎，再索而得男，故谓之中男；离，再索而得女，故谓之中女；
        艮，三索而得男，故谓之少男；兑，三索而得女，故谓之少女。
      </p>
      <p>
        乾为天，为圜，为君，为父，为玉，为金，为寒，为冰，为大赤，为良马，为老马，为瘠马，为驳马，为木果。
      </p>
      <p>
        坤为地，为母，为布，为釜，为吝啬，为均，为子母牛，为大舆，为文，为众，为柄；其于地也，为黑。
      </p>
      <p>
        震为雷，为龙，为玄黄，为旉，为大涂，为长子，为决躁，为苍筤竹，为萑苇；其于马也，为善鸣，为馵足，为作足，为的颡；其于稼也，为反生；其究为健，为蕃鲜。
      </p>
      <p>
        巽为木，为风，为长女，为绳直，为工，为白，为长，为高，为进退，为不果，为臭；其于人也，为寡发，为广颡，为多白眼，为近利市三倍；其究为躁卦。
      </p>
      <p>
        坎为水，为沟渎，为隐伏，为矫𫐓，为弓轮；其于人也，为加忧，为心病，为耳痛，为血卦，为赤；其于马也，为美脊，为亟心，为下首，为薄蹄，为曳；其于舆也，为多眚，为通，为月，为盗；其于木也，为坚多心。
      </p>
      <p>
        离为火，为日，为电，为中女，为甲胄，为戈兵；其于人也，为大腹，为乾卦，为鳖，为蟹，为蠃，为蚌，为龟；其于木也，为科上槁。
      </p>
      <p>
        艮为山，为径路，为小石，为门阙，为果蓏，为阍寺，为指，为狗，为鼠，为黔喙之属；其于木也，为坚多节。
      </p>
      <p>
        兑为泽，为少女，为巫，为口舌，为毁折，为附决；其于地也，为刚卤，为妾，为羊。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
